import { DateInputViewModel, ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps, Label, FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms date.
 * @see [Original Date Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/date.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - Date properties.
 * @returns A date field.
 */
export const BaseDate: FC<ValueFieldProps<DateInputViewModel>> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      <input
        type="date"
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={formatValue(value)}
        min={formatValue(field.model.min)}
        max={formatValue(field.model.max)}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      />
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function formatValue(value?: string) {
  if (!value || value.length < 10) {
    return value;
  }

  return value.substring(0, 10);
}

function handleOnChange(field: ValueFormField, fieldValue: string, callback: FieldChangeCallback) {
  const errorMessages = [];
  let valid = true;

  if (field.model.required && !fieldValue) {
    errorMessages.push(`${field.model.title} is required`);
    valid = false;
  }

  callback(field.valueField.name, fieldValue, valid, errorMessages);
}
